const apiUrl = process.env.REACT_APP_API_URL;
export const GetUsuariIdJutgeActivitatsAlumnes = async (id_projecte : string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/activitats/${id_projecte}/alumnes`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
